document.addEventListener('turbolinks:load', function() {
  const navbarTrialItemDesktop = document.querySelector(
    '.page-header--navbar-exp-v2 .page-header-sub-nav__list .trial-button'
  );
  const navbarTrialItemMobile = document.querySelector(
    '.page-header--navbar-exp-v2 .page-header-main__nav .trial-button'
  );
  const startScroll = 144;
  const togglePageHeaderTrialButton = () => {
    let currentScroll = window.scrollY || document.documentElement.scrollTop;

    if (currentScroll > startScroll) {
      navbarTrialItemDesktop.style.display = 'table-cell';
      navbarTrialItemDesktop.style.visibility = 'visible';
      requestAnimationFrame(() => {
        navbarTrialItemDesktop.style.opacity = '1';
      });

      navbarTrialItemMobile.style.visibility = 'visible';
      navbarTrialItemMobile.style.opacity = '1';
    } else {
      navbarTrialItemDesktop.style.opacity = '0';
      navbarTrialItemMobile.style.opacity = '0';
      setTimeout(() => {
        if (window.scrollY <= startScroll) {
          navbarTrialItemDesktop.style.visibility = 'hidden';
          navbarTrialItemDesktop.style.display = 'none';
          navbarTrialItemMobile.style.visibility = 'hidden';
        }
      }, 200);
    }
  };

  if (navbarTrialItemDesktop && navbarTrialItemMobile) {
    window.addEventListener('scroll', togglePageHeaderTrialButton);
  }
});
